import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core'

import * as R from 'ramda'
import React, { FC } from 'react'
import styled from 'styled-components'

import BlogTableBody from '../../components/blog/BlogTableBody'
import { BlogListInterface } from '../../interfaces/blog'
import { Pagination } from '../../interfaces/common'
import TablePaperContainer from '../common/TablePaperContainer'

const StyledTableHead = styled(TableHead)`
  background-color: rgba(0, 0, 0, 0.02);
`

const StyledTableHeadCell = styled(TableCell)`
  font-size: 16px !important;
  font-weight: 700 !important;
`

const BlogListTable: FC<any> = ({
  blogList,
  handleChangePage,
  handleChangeRowsPerPage
}: {
  blogList: Pagination<BlogListInterface> | null
  handleChangePage: (...args: any) => void
  handleChangeRowsPerPage: (...args: any) => void
}) => {
  const blogs = R.pathOr([], ['result'], blogList)
  const page = R.pathOr(1, ['page'], blogList)
  const limit = R.pathOr(50, ['limit'], blogList)
  const total = R.pathOr(0, ['total'], blogList)

  const columnNameList = ['Id', 'Title', 'Status', 'Updated At', 'Updated By']

  return (
    <TablePaperContainer>
      <TableContainer component={Paper} style={{ height: 'inherit' }}>
        <Table aria-label="sticky pagination table">
          <StyledTableHead>
            <TableRow>
              {columnNameList.map((name) => (
                <StyledTableHeadCell align="center">{name}</StyledTableHeadCell>
              ))}
            </TableRow>
          </StyledTableHead>
          <BlogTableBody blogs={blogs} />
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[50, 100]}
        count={total}
        rowsPerPage={limit}
        page={page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        style={{ minWidth: '500px' }}
      />
    </TablePaperContainer>
  )
}

export default BlogListTable
